(function() {
    'use strict';

    angular.module('ib-passenger-info-form-module', [
        'ib-passenger-basic-info-module',
        'ib-destination-info-module',
        'ib-passenger-visa-module',
        'ib-passenger-docs-module'
    ]);
})();